module.exports = __webpack_public_path__ + "img/header-calendar.288310df.png";